// Recovery guide for blocked push notifications
// Detects browser and platform, returns step-by-step instructions

export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export function getBrowserName() {
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return 'android-chrome';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios-safari';
  if (/Chrome/i.test(ua) && !/Edg/i.test(ua)) return 'chrome';
  if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) return 'safari';
  if (/Firefox/i.test(ua)) return 'firefox';
  if (/Edg/i.test(ua)) return 'edge';
  return 'chrome';
}

export function getBrowserLabel() {
  const browser = getBrowserName();
  const labels = {
    'android-chrome': 'Android Chrome',
    'ios-safari': 'iOS Safari',
    'chrome': 'Chrome',
    'safari': 'Safari',
    'firefox': 'Firefox',
    'edge': 'Edge',
  };
  return labels[browser] || 'your browser';
}

export function getRecoverySteps() {
  const browser = getBrowserName();

  // ── Mobile: Android Chrome ──
  if (browser === 'android-chrome') {
    return [
      { text: 'Open Chrome app → tap the three-dot menu (⋮) top-right' },
      { text: 'Tap "Settings" → "Site Settings"' },
      { text: 'Tap "Notifications"' },
      { text: 'Find this website in the "Blocked" section' },
      { text: 'Tap it → change to "Allow"' },
      { text: 'Come back here and tap "Try Again"' },
    ];
  }

  // ── Mobile: iOS Safari ──
  if (browser === 'ios-safari') {
    return [
      { text: 'Open iPhone Settings app (the gray ⚙️ gear icon)' },
      { text: 'Scroll down → tap "Safari"' },
      { text: 'Scroll down → tap "Notifications"' },
      { text: 'Find this website in the list' },
      { text: 'Toggle "Allow Notifications" to ON (green)' },
      { text: 'Come back here and tap "Try Again"' },
    ];
  }

  // ── Desktop: Chrome / Edge ──
  if (browser === 'chrome' || browser === 'edge') {
    return [
      { text: 'Click the 🔒 lock icon or ℹ️ icon in the address bar (left of the URL)' },
      { text: 'Find "Notifications" in the popup' },
      { text: 'Change it from "Block" to "Allow"' },
      { text: 'Refresh this page, then click "Try Again"' },
    ];
  }

  // ── Desktop: Safari ──
  if (browser === 'safari') {
    return [
      { text: 'Open Safari → Preferences (or Settings) → Websites tab' },
      { text: 'Click "Notifications" on the left sidebar' },
      { text: 'Find this website in the list' },
      { text: 'Change from "Deny" to "Allow"' },
      { text: 'Refresh this page, then click "Try Again"' },
    ];
  }

  // ── Desktop: Firefox / other ──
  return [
    { text: 'Open your browser Settings → Privacy & Security → Notifications' },
    { text: 'Find this website in the block list' },
    { text: 'Change from "Block" to "Allow"' },
    { text: 'Refresh this page, then click "Try Again"' },
  ];
}
